import { useTheme } from "../lib/theme";

/**
 * Subtle paper-texture overlay that uses the brand pattern asset.
 * Renders only in light mode and stays behind content (z-0).
 */
export default function PaperOverlay({ size = 720, opacity = 0.55 }) {
  const { theme } = useTheme();
  if (theme === "dark") return null;
  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage: "url('/brand/pattern.png')",
        backgroundSize: `${size}px`,
        backgroundRepeat: "repeat",
        mixBlendMode: "multiply",
        opacity,
        zIndex: 0,
      }}
    />
  );
}
